module.exports = __webpack_public_path__ + "img/ico-save.38542fe5.svg";